export const createResponsiveBreakpoints = (breakpoints) =>
  breakpoints.map(({ breakpoint, ...rest }) => ({
    breakpoint,
    settings: {
      ...rest,
    },
  }));
